import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { SettingProps } from "../setting/Settings";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import UserController from "../../controller/UserController";

const PasswordSetting = ({ passwordType, setStep }: SettingProps) => {
  const navigate = useNavigate();
  const [isCheck, setIsCheck] = useState<number>(-1);

  const getUserInfo = async () => {
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    if (oUserData.use_password === 0) {
      setIsCheck(0);
    } else if (oUserData.use_password === 1) {
      setIsCheck(1);
    }
  }

  const setUserPassword = async (iNumber: number) => {

    if (iNumber === 0) {
      setIsCheck(1);
    } else if (iNumber === 1) {
      setIsCheck(1);
    }
  }

  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <div className="wrapper">
      <h1 className="logo">
        {passwordType! === "payment" ? "결제" : "로그인"} 시 항상 비밀번호를
        입력하시겠습니까?
      </h1>
      <div className="listWrap">
        <div className={`buttonBorder ${isCheck === 1 && "active"}`}>
          <button onClick={() => { setUserPassword(1); }} >
            <h1 className="img">YES</h1>
            <h1>매번 입력할래요</h1>
          </button>
        </div>
        <div className={`buttonBorder ${isCheck === 0 && "active"}`}>
          <button onClick={() => { setUserPassword(0); }} >
            <h1 className="img">NO</h1>
            <h1>안할래요</h1>
          </button>
        </div>
      </div>
    </div>
  );
};
export default PasswordSetting;
